module.exports = __webpack_public_path__ + "static/media/placeholder.23680846.jpg";